<app-layout>
    <div class="main-container">
        <app-org-chart-display></app-org-chart-display>
    </div>
</app-layout>
